export default __webpack_public_path__ + "static/accelerate-ai-85beff0045591aad92e474af54ff4bca.png";